export default __webpack_public_path__ + "static/media/sounds/trcMicVerificationFailure.mp3";